import {ReadonlyDeep} from 'type-fest';
import {FarmState} from '../../ApiStore';

export default (state?: ReadonlyDeep<FarmState>): boolean =>
  state?.cpu_states.some((_) => _.hot) ?? false;
